import VueResizable from "./components/vue-resizable";

export default VueResizable;
